export default "__VITE_ASSET__BBG82z2Z__"